import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";
import Loader from "../../components/Loader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";

const fmtDate = (v) => (v ? String(v).replace("T", " ").slice(0, 19) : "-");
const statusColor = (s) => (s === "SUCCESS" ? "success" : s === "FAILED" ? "error" : "default");

// The campaign is configured in USD; what the wallet actually moved is stored
// alongside it in the player's own currency, so both are shown.
const amount = (credited, currency) =>
  Number(credited || 0) > 0 ? `${Number(credited)} ${currency || ""}`.trim() : "-";
const usd = (v) => (Number(v || 0) > 0 ? `$${Number(v).toFixed(2)}` : "-");

const PromoUsageModal = ({ promo, onClose }) => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const open = !!promo;

  useEffect(() => {
    if (!promo?.id) { setRows([]); return; }
    (async () => {
      setIsLoading(true);
      try {
        const response = await getAllData(`${endPoints.api.PROMO_CAMPAIGN_USAGE}/${promo.id}`);
        if (response.status === "success") setRows(response.data || []);
        else setRows([]);
      } catch (e) {
        console.error(e);
        setRows([]);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [promo]);

  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
      <DialogTitle sx={{ pr: 6 }}>
        Redemptions{promo?.promoCode ? ` — ${promo.promoCode}` : ""}
        <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8, color: "#64607a" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <TableContainer component={Paper}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="center">User ID</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Cash (USD)</TableCell>
                <TableCell align="center">Bonus (USD)</TableCell>
                <TableCell align="center">Cash credited</TableCell>
                <TableCell align="center">Bonus credited</TableCell>
                <TableCell align="center">Free Spins</TableCell>
                <TableCell align="center">Reason</TableCell>
                <TableCell align="center">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={9} align="center">No redemptions yet.</TableCell></TableRow>
              )}
              {rows.map((r, i) => (
                <TableRow key={r.id || i}>
                  <TableCell align="center">{r.userId}</TableCell>
                  <TableCell align="center"><Chip size="small" label={r.status} color={statusColor(r.status)} /></TableCell>
                  <TableCell align="center">{usd(r.cashRewardUsd)}</TableCell>
                  <TableCell align="center">{usd(r.bonusRewardUsd)}</TableCell>
                  <TableCell align="center">{amount(r.cashCredited, r.currency)}</TableCell>
                  <TableCell align="center">{amount(r.bonusCredited, r.currency)}</TableCell>
                  <TableCell align="center">{r.freeSpins || 0}</TableCell>
                  <TableCell align="center">{r.failReason || "-"}</TableCell>
                  <TableCell align="center">{fmtDate(r.createdAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default PromoUsageModal;
